import React, { useMemo } from "react";
import styles from "./Table.module.scss";
import ReactPaginate from "react-paginate";
import { combineClasses } from "@/lib/utils";
import ArrowIcon from "../SVGComponents/ArrowIcon";
import { useSelector } from "react-redux";
import { PAGINATION } from "@/lib/constants";

const Pagination = (props: any) => {
  const {
    totalCount = 0,
    pageSelected,
    setPageSelected,
    rowsPerPageValue = PAGINATION.DEFAULT_ROWS_PER_PAGE,
  } = props;
  const { sidebarOpen } = useSelector((state: any) => state?.global);
  const noOfPages = useMemo(
    () => Math.ceil(totalCount / rowsPerPageValue),
    [rowsPerPageValue, totalCount]
  );

  const handlePageClick = (e: any) => {
    setPageSelected(e?.selected + 1);
  };

  const startingData = totalCount === 0 ? 0 : (pageSelected - 1) * rowsPerPageValue + 1;
  const endingData = Math.min(pageSelected * rowsPerPageValue, totalCount);

  return (
    <div
      className={combineClasses(
        styles.pagination,
        sidebarOpen && styles.sidebarOpen
      )}
    >
      <p className={styles.dataRange}>
        {`Showing ${startingData}-${endingData} of ${totalCount}`}
      </p>
      <div className={styles.paginationRightSide}>
        <ReactPaginate
          breakLabel="..."
          breakClassName={styles.page}
          previousClassName={combineClasses(styles.page, styles.arrowBox)}
          previousLabel={
            <ArrowIcon
              className={combineClasses(styles.arrow, styles.previousArrow)}
            />
          }
          nextClassName={combineClasses(
            styles.page,
            styles.arrowBox,
            pageSelected === noOfPages ? styles.disabled : ""
          )}
          nextLabel={
            <ArrowIcon
              className={combineClasses(styles.arrow, styles.nextArrow)}
            />
          }
          renderOnZeroPageCount={null}
          pageCount={noOfPages}
          containerClassName={styles.paginationContainer}
          activeClassName={styles.activePage}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          onPageChange={handlePageClick}
          disabledClassName={styles.disabled}
          pageClassName={styles.page}
          forcePage={pageSelected - 1}
        />
      </div>
    </div>
  );
};

export default Pagination;
